import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { AanwezigenType as FormTypes } from "../forms/AanwezigenInput";
import * as AanwezighedenIcon from "../../atoms/icons/AanwezigenIcon";
import { useTranslation } from 'react-i18next';

export const AanwezigenType = FormTypes;

// All the incoming values
interface IProps {
    type?: FormTypes;
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<number>;
export const Aanwezigen = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const type = props.type || AanwezigenType.Default;
    const { t: tDatatypes } = useTranslation('datatypes');


    const label = props.label || (() => {
        switch (type) {
            case AanwezigenType.Professioneel:
                return tDatatypes('aanwezigenLabelProfessioneel');
            case AanwezigenType.NietProfessioneel:
                return tDatatypes('aanwezigenLabelNietProfessioneel');
            default:
                return tDatatypes('aanwezigenLabelDefault');	
        }
    })() || tDatatypes('aanwezigenLabelDefault') || "Aanwezigen";
    
    const icon = (() => {
        switch (type) {
            case AanwezigenType.Professioneel:
                return <AanwezighedenIcon.AanwezigenProfessioneel />;
            case AanwezigenType.NietProfessioneel:
                return <AanwezighedenIcon.AanwezigenNietProfessioneel />;
            default:
                return <AanwezighedenIcon.AanwezigenDefault />;
        }
    })();

    return (<Caption {...props} caption={label} icon={icon}>
        {props.value}
    </Caption>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));